import React from "react";
import { Link } from "gatsby";

import imgL1Logo from "../../assets/image/logo-main-black.png";
// import imgL1LogoWhite from "../../assets/image/logo-main-white.png";
import imgL1LogoWhite from "../../assets/hkb/image/logo-main.jpg";

const Logo = ({ white, height, className = "", ...rest }) => {
  return (
    <Link to="/" className={`d-block ${className}`} {...rest}>
      {white ? (
        <img src={imgL1LogoWhite} alt="Connecting Filipinos with Trusted Helpers for Every Need." width={80} />
      ) : (
        <img src={imgL1LogoWhite} alt="Connecting Filipinos with Trusted Helpers for Every Need." width={80} />
      )}
    </Link>
  );
};

export default Logo;
